import { AddBankAccountTask } from '../../common/tasks/AddBankAccountTask';
import { ServiceRequestSendEmailCardTask } from '../../common/tasks/ServiceRequestSendEmailCardTask';
import { ApproveCompanyDetails } from '../common/ApproveCompanyDetails';
import { BankWireInstructionsUpload } from '../common/BankWireInstructionsUpload';
import { EINLetter } from '../common/EINLetter';
import { EINProof } from '../common/EINProof';
import { FillCompanyDetails } from '../common/FillCompanyDetails';
import { IncorporationDetails } from '../common/IncorporationDetails';
import { MarkAsFiledComponent } from '../common/MarkAsFiled';
import { USUploadIncorporationDocuments } from '../common/UploadIncorporationDocuments';
import { BOIFilingAcknowledgementUpload } from '../common/BOIAckUpload';
import { USLLCIncorporationTasks } from './config';

export const US_LLC_INCORPORATION_COMPONENT_MAP = {
  // Company Formation Details
  [USLLCIncorporationTasks.FILL_CORPORATION_DETAILS]: FillCompanyDetails,
  [USLLCIncorporationTasks.REVIEW_CORPORATION_DETAILS]: ApproveCompanyDetails,

  // Incorporation Filing
  [USLLCIncorporationTasks.FILE_INCORPORATION]: MarkAsFiledComponent,
  [USLLCIncorporationTasks.UPLOAD_INCORPORATION_DOCUMENTS]:
    USUploadIncorporationDocuments,
  [USLLCIncorporationTasks.FILL_INCORPORATION_DETAILS]: IncorporationDetails,
  [USLLCIncorporationTasks.SEND_EMAIL_UPDATE]: ServiceRequestSendEmailCardTask,

  // EIN Proof
  [USLLCIncorporationTasks.UPLOAD_EIN_PROOF]: EINProof,

  // EIN Letter
  [USLLCIncorporationTasks.UPLOAD_EIN_LETTER]: EINLetter,

  // Bank Account Creation
  [USLLCIncorporationTasks.CLIENT_ADD_BANK_ACCOUNT]: AddBankAccountTask,
  [USLLCIncorporationTasks.CLIENT_UPLOAD_BANK_WIRE_INSTRUCTIONS]:
    BankWireInstructionsUpload,

  // BOI Filing
  [USLLCIncorporationTasks.BOI_FILING_ACKNOWLEDGEMENT]:
    BOIFilingAcknowledgementUpload,
};
